import { isEqual } from "lodash";
import { useState } from "react";

import { AbsenceStatusQuickFilter } from "./interfaces";

export const useAbsencesStatusesQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<AbsenceStatusQuickFilter>({
    absencesStatuses: {
      absenceStatuses: [],
    },
  });

  const handleChangeQuickFilter = (
    filter: keyof AbsenceStatusQuickFilter,
    value: AbsenceStatusQuickFilter["absencesStatuses"]
  ) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    absencesStatusesQuickFilter: quickFilter,
    setAbsencesStatusesQuickFilter: handleChangeQuickFilter,
  };
};
